import { Link } from "react-router-dom";
import { useMemberAuth } from "@/context/MemberAuthContext";
import { LogOut } from "lucide-react";

export const MemberBar = () => {
  const { member, logout } = useMemberAuth();
  if (member === null) return <div className="h-[52px] mb-8" />;
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 card-surface px-5 py-3 mb-8" data-testid="member-bar">
      {member ? (
        <>
          <p className="text-sm text-brand-textSec">
            Signed in as <span className="text-white font-medium" data-testid="member-name">{member.name}</span>
          </p>
          <button onClick={logout} className="text-sm text-brand-textSec hover:text-brand-cyan inline-flex items-center gap-2 self-start sm:self-auto" data-testid="member-logout-btn">
            <LogOut size={14} /> Log out
          </button>
        </>
      ) : (
        <>
          <p className="text-sm text-brand-textSec">Join the community to start topics and reply.</p>
          <div className="flex gap-2">
            <Link to="/forum/join" className="btn-ghost px-4 py-2 text-sm" data-testid="member-login-link">Log in</Link>
            <Link to="/forum/join?mode=register" className="btn-primary px-4 py-2 text-sm" data-testid="member-signup-link">Sign up free</Link>
          </div>
        </>
      )}
    </div>
  );
};

export const fmtWhen = (iso) => {
  try {
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
};
